import { memo, useEffect, useId, useRef } from 'react';

import { cn } from '@air/utils-tailwind';

import { PrivateWorkspaceAgentPanelComposerCreditsDepletedMessage } from '~/components/v2/components/workspace/workspace-agent-panel/components/composer/PrivateWorkspaceAgentPanelComposerCreditsDepletedMessage';
import { workspaceAgentComposerShell } from '~/components/v2/components/workspace/workspace-agent-panel/constants/workspaceAgentComposerChrome';

/**
 * Covers the composer footprint (same grid-stack pattern as consent dock) when credits are depleted
 * and no agent run is in flight.
 */
export const PrivateWorkspaceAgentPanelComposerCreditsDepletedDock = memo(() => {
  const dockRef = useRef<HTMLElement>(null);
  const headingId = useId();

  useEffect(() => {
    dockRef.current?.focus({ preventScroll: true });
  }, []);

  return (
    <section
      aria-labelledby={headingId}
      className={cn(workspaceAgentComposerShell(), 'flex min-h-0 flex-1 flex-col justify-start px-3 pt-2 pb-2')}
      data-testid="WORKSPACE_AGENT_COMPOSER_CREDITS_DEPLETED_BANNER"
      ref={dockRef}
      tabIndex={-1}
    >
      <PrivateWorkspaceAgentPanelComposerCreditsDepletedMessage headingId={headingId} trackViewOnMount />
    </section>
  );
});

PrivateWorkspaceAgentPanelComposerCreditsDepletedDock.displayName =
  'PrivateWorkspaceAgentPanelComposerCreditsDepletedDock';
